<!-- Side column todays quarte races start -->
<div class="mt-2">
  <p-accordion *ngIf=" !loading ">
    <p-accordionTab [(selected)]="!collapsed" header="{{ 'QUARTE_RACES.HEADER_TITLE' | translate }}">
      <div class="tabbassiCard card col">
        <div class="card-body text-break table-small-text p-0">
          <table class="table table-striped mb-0">
            <tbody>
              <tr class="row-hover" *ngFor="let item of quarteRaces" (click)="goToRaceDetails(item)">
                <td class="w-3 px-0 race-type-icon">
                  <img src="../../../../assets/media/icons/{{getRaceType(item)}}.webp" [alt]="getRaceType(item)"
                    [pTooltip]="getRaceType(item)" tooltipPosition="right" />
                </td>
                <td>{{ item.Track }}</td>
                <td class="pr-0" [style.white-space]="'nowrap'">
                  {{ "RACES.RACE_C" | translate | raceCourse : item.Number : true }}
                </td>
                <td class="remaining-time" *ngIf="item.dateDiffMin > 59">{{item.dateDiffHour + ' Hr..'}} </td>
                <td class="remaining-time" *ngIf="item.dateDiffMin < 2 && item.dateDiffMin > 0">
                  {{ '2 min.'}}
                </td>
                <td class="remaining-time" *ngIf="item.dateDiffMin < 0 && item.IsResult">
                  {{ 'QUARTE_RACES.FINISHED' | translate}}
                </td>
                <td class="remaining-time" *ngIf="item.dateDiffMin < 0 && !item.IsResult">
                  {{ '---' | translate}}
                </td>
                <td class="remaining-time" *ngIf="item.dateDiffMin >= 2 && item.dateDiffMin < 60 ">
                  {{ item.dateDiffMin + ' min.'}} </td>
              </tr>
              <tr *ngIf="quarteRaces.length === 0">
                <td>
                  {{ 'QUARTE_RACES.NO_RACE' | translate}} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>
<!-- Side column todays quarte races end -->

<app-loading-screen *ngIf="loading"></app-loading-screen>